import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Breadcrumb } from '../../../../core/model';
import { CatalogSearchService } from '../../container/catalog/catalog-search.service';

@Component({
  selector: 'py-catalog-filter-breadcrumbs',
  templateUrl: './catalog-filter-breadcrumbs.component.html',
  styleUrls: ['./catalog-filter-breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CatalogFilterBreadcrumbsComponent implements OnInit {
  @Input() breadcrumbs: Breadcrumb[];

  articleNumber$: Observable<string>;

  constructor(
    private catalogSearchService: CatalogSearchService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.articleNumber$ = this.activatedRoute.queryParamMap.pipe(map((params) => params?.get('a')));
  }

  clearFilter(breadcrumb: Breadcrumb): void {
    this.catalogSearchService.setQuery(breadcrumb?.removeQuery?.query?.value);
  }

  onResetFacets(): void {
    this.catalogSearchService.resetPDPFilters();
  }
}
